<template>
<span :class="classes">
    <img
        :class="bem('inner')"
        :style="styles"
        :src="resolvedSrc"
        :alt="alt"
    >
    <template v-if="mark">
        <span
            v-if="addedType"
            :class="bem('add-mark', [addedType.mark])"
        >{{ addedType.name }} </span>
        <span
            v-else
            :class="bem('mark', [mark])"
        />
    </template>
</span>

</template>
<script>
import {bemMixin} from "../utils";
import ossDprURL from "../utils/oss-dpr-url";
const DEFAULT_AVATAR = "https://st-gdx.dancf.com/gaodingx/152/configs/system/20190620-155354-47e9.png";
const CDN_REGEXP = /dancf.com/i;
const SIZE_MAP = {
  small: 72,
  default: 88,
  large: 224
};
export default {
  name: "g-avatar",
  mixins: [bemMixin],
  props: {
    src: String,
    size: {
      type: [Number, String],
      default: "default"
    },
    mark: {
      type: String,
      require: true,
      default: ""
    },
    alt: String
  },
  data() {
    return {
      addedVipTypes: [
        {
          name: "个人专业版",
          mark: "pvip"
        },
        {
          name: "个人专业版",
          mark: "pvip-times"
        },
        {
          name: "新媒体商户版",
          mark: "media-purpose-svip"
        },
        {
          name: "全用途商户版",
          mark: "all-purpose-svip"
        }
      ]
    };
  },
  computed: {
    isCustomSize() {
      return typeof this.size === "number";
    },
    resolvedSrc() {
      let src = this.src || DEFAULT_AVATAR;
      if (CDN_REGEXP.test(src)) {
        src += `?x-oss-process=image/resize,w_${this.computedSize}/interlace,1`;
      }
      return ossDprURL(src);
    },
    classes() {
      return this.bem("", [this.isCustomSize || this.size === "default" ? "" : `${this.size}`]);
    },
    styles() {
      return this.isCustomSize ? {
        width: `${this.size}px`,
        height: `${this.size}px`
      } : null;
    },
    computedSize() {
      if (this.isCustomSize) {
        return this.size * 2;
      }
      return SIZE_MAP[this.size];
    },
    addedType() {
      return this.addedVipTypes.find((vip) => vip.mark === this.mark);
    }
  }
};

</script>
<style>
.g-avatar {
  display: inline-block;
  vertical-align: middle;
  position: relative;
}
.g-avatar--large .g-avatar__inner {
  width: 112px;
  height: 112px;
}
.g-avatar--small .g-avatar__inner {
  width: 36px;
  height: 36px;
}
.g-avatar--small .g-avatar__mark {
  width: 50px;
  height: 16px;
}
.g-avatar__inner {
  display: block;
  position: relative;
  top: -2px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: cover;
}
.g-avatar__mark {
  position: absolute;
  bottom: -2px;
  left: 50%;
  transform: translate3d(-50%, 0, 0);
  width: 34px;
  height: 14px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center bottom;
}
.g-avatar__mark--old-vip {
  background-image: url(https://st-gdx.dancf.com/gaodingx/345/configs/vip_promotion/20200429-182522-04cf.svg);
}
.g-avatar__mark--company-standard-vip {
  background-image: url(https://st-gdx.dancf.com/gaodingx/345/configs/vip_promotion/20200429-141141-8e7e.svg);
}
.g-avatar__mark--old-svip {
  background-image: url(https://st-gdx.dancf.com/gaodingx/345/configs/vip_promotion/20200429-182556-4f0c.svg);
}
.g-avatar__mark--company-senior-vip {
  background-image: url(https://st-gdx.dancf.com/gaodingx/345/configs/vip_promotion/20200429-141428-22b9.svg);
}
.g-avatar__add-mark {
  width: 84px;
  height: 21px;
  line-height: 21px;
  text-align: center;
  border-radius: 15px;
  position: absolute;
  bottom: -4px;
  left: 50%;
  transform: translate3d(-50%, 0, 0) scale(0.6666);
  font-family: PingFang SC;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  color: #fff;
}
.g-avatar__add-mark--pvip,
.g-avatar__add-mark--pvip-times {
  background: linear-gradient(92.24deg, #5c7399 2.12%, #50698e 100%);
}
.g-avatar__add-mark--media-purpose-svip {
  background: linear-gradient(92.24deg, #1f677d 2.12%, #1d4c5b 100%);
}
.g-avatar__add-mark--all-purpose-svip {
  background: linear-gradient(92.24deg, #666896 2.12%, #4a5080 100%);
}

</style>
